import React from 'react';

const TaskDetailSkeleton: React.FC = () => {
  return (
    <div className="animate-pulse flex flex-col flex-1 min-h-0 w-full pt-6">
      {/* Header Section Skeleton */}
      <div className="flex justify-between items-center gap-4 flex-wrap pb-4 px-[30px] max-991:px-[20px] border-b border-primary-subtle shrink-0">
        <div className="flex items-center gap-3">
          <div className="w-5 h-5 bg-primary-subtle rounded-md"></div>
          <div className="w-48 h-5 bg-primary-subtle rounded-md"></div>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-28 h-8 bg-primary-subtle rounded-lg"></div>
          {/* <div className="w-10 h-8 bg-primary-subtle rounded-lg"></div> */}
          <div className="w-10 h-8 bg-primary-subtle rounded-lg"></div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row flex-1 min-h-0 overflow-hidden">
        {/* Main Content (Left) Skeleton */}
        <div className="flex-1 overflow-hidden pt-6 px-[30px] max-991:px-[20px] space-y-6">
          <div className="flex items-center gap-3 pb-4">
            <div className="w-24 h-8 bg-primary-subtle rounded-lg"></div>
            <div className="w-64 h-8 bg-primary-subtle rounded-lg"></div>
          </div>
          
          <div className="w-full h-32 bg-primary-subtle rounded-lg"></div>
          
          <div className="space-y-4">
             <div className="w-40 h-6 bg-primary-subtle rounded-md"></div>
             <div className="w-full h-20 bg-primary-subtle rounded-lg"></div>
          </div>

          <div className="space-y-4">
             <div className="w-40 h-6 bg-primary-subtle rounded-md"></div>
             <div className="w-full h-20 bg-primary-subtle rounded-lg"></div>
          </div>
        </div>

        {/* Sidebar (Right) Skeleton */}
        <div className="w-full md:w-80 border-l border-primary-subtle px-6 pt-6 pb-6 space-y-6 overflow-hidden min-h-0">
          {Array.from({ length: 6 }).map((_, idx) => (
            <div key={idx}>
              <div className="w-20 h-4 bg-primary-subtle rounded-md mb-2"></div>
              <div className="w-full h-10 bg-primary-subtle rounded-lg"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TaskDetailSkeleton;
